import React, { useCallback } from 'react';
import clsx from 'clsx';
import { makeStyles } from 'react-scale/components/design-system/styles';
import ReactTooltip from 'react-tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Kbd from 'react-scale/components/design-system/Kbd';
import { DefaultToolTipHeaderProps } from '../../types';

const useStyles = makeStyles({
  header: {
    minHeight: 25,
    display: 'flex',
    fontWeight: 200,
    fontSize: '15px',
    justifyContent: 'space-between',
    '&.isCompleted': {
      opacity: 0.3,
    },
    padding: 8,
    borderBottom: '1px solid var(--color-RemoGray10)',
  },
  title: {
    fontWeight: 500,
    alignSelf: 'center',
  },
  iconToggle: {
    cursor: 'pointer',
    fontSize: '16px',
  },
});

/**
 * Default ToolTip for GWFBar - Shows Current Step Name & Close Button
 */
const DefaultToolTipHeader: React.FC<DefaultToolTipHeaderProps> = props => {
  const classes = useStyles();

  const { toggleIsGuidedWorkflowTooltipOpen, workflowState } = props.workflowHook;
  const { currentStep } = workflowState;

  const isCompleted = workflowState.completedStepIds.includes(currentStep.id);

  const handleCloseTooltip: React.MouseEventHandler = useCallback(
    e => {
      e.stopPropagation();
      toggleIsGuidedWorkflowTooltipOpen();
    },
    [toggleIsGuidedWorkflowTooltipOpen],
  );

  return (
    <div className={clsx(classes.header, { isCompleted })}>
      <div className={classes.title}>{currentStep.name}</div>
      <div
        className={classes.iconToggle}
        onClick={handleCloseTooltip}
        data-tip
        data-for="nextButton"
        data-effect="solid"
        data-place="bottom"
      >
        <ReactTooltip id="nextButton">
          {
            <div>
              Open / Close Tooltip <Kbd>T</Kbd>
            </div>
          }
        </ReactTooltip>
        <FontAwesomeIcon icon="times" color="grey" />
      </div>
    </div>
  );
};

export default DefaultToolTipHeader;
